import { Tooltip as ReactTooltip, type PlacesType } from "react-tooltip";
import { twMerge } from "tailwind-merge";
import * as React from "react";
import Chip from "./Chip";
import Text from "./Text";

export type TooltipProps = {
  content?: string;
  badge?: string;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  align?: "start" | "center" | "end";
  position?: "top" | "bottom";
};

export default function Tooltip({
  content,
  badge,
  children,
  className,
  contentClassName,
  align = "center",
  position = "bottom",
}: TooltipProps) {
  const tooltipId = React.useId().replace(/:/g, "");

  if (!content) return <>{children}</>;
  return (
    <>
      <span
        children={children}
        data-tooltip-id={tooltipId}
        className={twMerge("inline-flex cursor-help", className)}
      />
      <ReactTooltip
        id={tooltipId}
        clickable
        place={`${position}-${align}` as PlacesType}
        className={twMerge("tooltip-panel", contentClassName)}
        content={
          <div className="flex flex-col items-start gap-[8px]">
            {badge ? <Chip label={badge} type="primary" solid /> : null}
            <Text>{content}</Text>
          </div>
        }
      />
    </>
  );
}
